import { Globe, Clapperboard, Palette, Layers } from "lucide-react";

const ICONS = { Globe, Clapperboard, Palette, Layers };

const STATUS = {
  new: "bg-sky-500/10 text-sky-700 border-sky-500/20",
  approved: "bg-primary/10 text-primary border-primary/30",
  saved: "bg-amber-500/10 text-amber-700 border-amber-500/20",
  skipped: "bg-zinc-500/10 text-zinc-600 border-zinc-500/20",
  blacklisted: "bg-red-500/10 text-red-700 border-red-500/20",
  drafted: "bg-violet-500/10 text-violet-700 border-violet-500/20",
  draft: "bg-violet-500/10 text-violet-700 border-violet-500/20",
  pushed: "bg-blue-500/10 text-blue-700 border-blue-500/20",
  sent: "bg-teal-500/10 text-teal-700 border-teal-500/20",
  replied: "bg-emerald-500/15 text-emerald-700 border-emerald-500/30",
  dead: "bg-zinc-500/10 text-zinc-500 border-zinc-500/20",
  reeligible: "bg-sky-500/10 text-sky-700 border-sky-500/20",
};

const LABEL = { pushed: "in outlook", draft: "in-app draft" };

export function StatusBadge({ status, testid }) {
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium capitalize ${STATUS[status] || STATUS.new}`}>
      {LABEL[status] || status}
    </span>
  );
}

const CONF = {
  high: "text-emerald-700 bg-emerald-500/10 border-emerald-500/25",
  medium: "text-amber-700 bg-amber-500/10 border-amber-500/25",
  low: "text-red-700 bg-red-500/10 border-red-500/25",
  none: "text-zinc-500 bg-zinc-500/10 border-zinc-500/20",
};

export function ConfidenceBadge({ level, testid }) {
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-md border px-1.5 py-0.5 font-mono text-[10px] uppercase ${CONF[level] || CONF.none}`}>
      {level === "none" ? "no email" : level}
    </span>
  );
}

export function TrackIcon({ name, className = "h-4 w-4", color }) {
  const I = ICONS[name] || Layers;
  return <I className={className} style={color ? { color } : undefined} strokeWidth={1.75} />;
}

export function ScoreBar({ score }) {
  const c = score >= 60 ? "bg-primary" : score >= 40 ? "bg-amber-400" : "bg-zinc-500";
  return (
    <div className="flex items-center gap-2">
      <span className="w-7 font-mono text-sm tabular-nums">{score}</span>
      <div className="h-1 w-14 overflow-hidden rounded-full bg-secondary">
        <div className={`h-full ${c}`} style={{ width: `${score}%` }} />
      </div>
    </div>
  );
}

export function PageHeader({ eyebrow, title, children }) {
  return (
    <div className="kh-rise flex flex-wrap items-end justify-between gap-4">
      <div>
        <div className="kh-eyebrow">{eyebrow}</div>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl">{title}</h1>
      </div>
      <div className="flex flex-wrap items-center gap-2">{children}</div>
    </div>
  );
}

export function Empty({ children, testid }) {
  return <div data-testid={testid} className="rounded-xl border border-dashed p-10 text-center text-sm text-muted-foreground">{children}</div>;
}
